import React from "react";

import useInsightInfos from "./hooks/useInsightInfos";
import InsightMenu from "./InsightMenu";

export function DynamicallyConfiguredInsightMenu(props) {
  const insights = useInsightInfos("reportButton");

  return <InsightMenu {...props} insights={insights} />;
}

DynamicallyConfiguredInsightMenu.propTypes = {};
DynamicallyConfiguredInsightMenu.defaultProps = {};

export default DynamicallyConfiguredInsightMenu;
